import * as types from '../constants/actionTypes';

export const setPortalCode = (portalQueryCode) => {
  return {
    type: types.SET_PORTAL_CODE,
    payload: portalQueryCode
  }
}